import Crud from '../views/Unit/Crud'
import Entity from '../views/Unit/Add'

let routes = {
    path: '/units',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/units/add',
            name: 'NewUnit',
            component: Entity,
            meta: {
                pageTitle: 'Unidade',
                breadcrumb: [
                    {
                        text: 'Adicionar Unidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/units/edit/:id?',
            name: 'EditUnit',
            component: Entity,
            meta: {
                pageTitle: 'Unidade',
                breadcrumb: [
                    {
                        text: 'Editar Unidade',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/units',
            name: 'list-units',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Unidades',
                breadcrumb: [
                    {
                        text: 'Unidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
